export type OnboardingStage = 'research' | 'setup' | 'context'

export interface PersistedOnboardingJourney {
  stage: OnboardingStage
  pendingWizardId: string | null
}

export const journeyStorageKey = (teamPid: string | number) => `onboarding_journey:${String(teamPid)}`

const isOnboardingStage = (value: unknown): value is OnboardingStage =>
  value === 'research' || value === 'setup' || value === 'context'

export const readPersistedOnboardingJourney = (teamPid: string | number): PersistedOnboardingJourney | null => {
  try {
    const raw = window.sessionStorage.getItem(journeyStorageKey(teamPid))
    if (!raw) {
      return null
    }

    const parsed = JSON.parse(raw) as Partial<PersistedOnboardingJourney> | null
    if (!parsed || !isOnboardingStage(parsed.stage)) {
      window.sessionStorage.removeItem(journeyStorageKey(teamPid))
      return null
    }

    const pendingId = typeof parsed.pendingWizardId === 'string' ? parsed.pendingWizardId : null
    if (parsed.stage === 'context' && !pendingId) {
      return null
    }

    return { stage: parsed.stage, pendingWizardId: pendingId }
  } catch {
    try {
      window.sessionStorage.removeItem(journeyStorageKey(teamPid))
    } catch {
      // Storage can be unavailable in restricted browser contexts.
    }
    return null
  }
}
